<template>
  <div id="ModalDelete">
    <transition name="fade">
      <div class="fixed inset-0 z-50" v-if="isDeleteModalVisible">
        <div>
          <div
            class="absolute inset-0 bg-black bg-opacity-75"
            @click="onDeleteModal"
          ></div>
          <div
            class="flex flex-col items-center justify-center w-screen h-screen"
          >
            <div class="relative animodal-inner">
              <div
                class="rounded-lg bg-white border border-stone-500 overflow-hidden"
              >
                <div v-if="!caseCreationSuccessMessage">
                  <div class="mt-3 mx-3 text-center">Confirm Delete user</div>
                  <hr />
                  <form class="mx-10 my-10">
                    <div>Are you sure you want to delete User?</div>
                    <div class="p-3 mt-2 text-center space-x-4 md:block">
                      <button
                        @click.prevent="onDeleteModal"
                        :disabled="caseLoading"
                        class="mb-2 md:mb-0 bg-black px-5 py-2 text-sm shadow-sm font-medium tracking-wider text-white rounded-md hover:shadow-lg"
                      >
                        No
                      </button>
                      <button
                        @click.prevent="createContactCase"
                        :disabled="caseLoading"
                        :class="caseLoading ? 'bg-gray-500' : 'bg-[#8DC63F]'"
                        class="mb-2 md:mb-0 px-5 py-2 text-sm shadow-sm font-medium tracking-wider border text-white rounded-md hover:shadow-lg"
                      >
                        <span v-if="caseLoading">Processing</span>
                        <span v-else>Yes</span>
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  v-else
                  class="text-center w-48 md:w-64 lg:w-[33rem] xl:w-[33rem]"
                >
                  <div v-if="caseCreationSuccessMessage">
                    <div class="text-center">
                      <div class="">
                        <font-awesome-icon
                          class="text-green-600 z-20 h-28 py-2"
                          icon="fa-check-circle"
                        />
                      </div>
                      <div class="py-2">
                        <div class="p-4 text-black">
                          <div class="text-lg font-bold text-center">
                            Delete request created successfully
                          </div>

                          <div class="mt-4 text-sm text-center font-normal">
                            Kindly track processing status from Tickets menu
                            using Case Number
                            <div class="block font-bold">
                              {{ caseCreationSuccessMessage }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="createCaseError" class="text-center">
                    <div class="">
                      <font-awesome-icon
                        class="text-red-600 z-20 h-28 py-2"
                        icon="fa-exclamation-circle"
                      />
                    </div>
                    <div class="py-2">
                      <div class="p-4 text-black">
                        <div class="text-lg font-bold text-center">
                          Delete request failed
                        </div>
                        <div class="mt-4 text-sm text-center font-bold">
                          {{ createCaseError }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { engageAxios, toolkitAxios } from "@/env";
import { ref } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    isDeleteModalVisible: Boolean,
    onDeleteModal: Function,
  },
  setup() {
    const caseLoading = ref(false);
    const store = useStore();
    const caseCreationError = ref("");
    const createCaseError = ref("");
    const caseCreationSuccessMessage = ref("");

    const createContactCase = async () => {
      let contact = store.state.getContact;

      caseLoading.value = true;

      const finalDesc =
        store.state.getLoggedInUser.code +
        "-" +
        "Contact Deletion" +
        " \n " +
        "First Name: " +
        contact?.name?.split(" ")[0] +
        " \n " +
        "Last Name: " +
        contact?.name?.split(" ")[1] +
        " \n " +
        "Email: " +
        contact?.email +
        " \n " +
        "Mobile Number: " +
        contact?.phone_number +
        " \n " +
        "Designation: " +
        contact?.designation +
        " \n " +
        "Department: " +
        contact?.department +
        " \n " +
        "Action: " +
        "Contact Deletion" +
        " \n ";

      const finalDto = {
        caseOriginCode: "700000008",
        employerCode: store.state.getLoggedInUser.code,
        interactionType: "700000000",
        interactionCategory: "718b7c3e-081d-eb11-a813-000d3a64a52d",
        interactionSubCategory: "073df4e1-081d-eb11-a813-000d3a64a52d",
        documents: [],
        caseDescription: finalDesc,
        // agentCode: store.state.getLoggedInUser.rmu_code,
        subject: store.state.getLoggedInUser.code + "-" + "Contact Deletion",
      };

      await engageAxios
        .post("crm/case/employer/createcase", finalDto)
        .then((res) => {
          const postData = {
            code: finalDto.employerCode,
            type: 4,
            agentCode: store.state.getLoggedInUser.rmu_code,
          };
          // console.log(postData)

          if (res.data.status === "success") {
            toolkitAxios
              .post("case/contact", postData)
              .then(() => {
                caseCreationSuccessMessage.value = res.data?.data?.caseNumber;
                // caseCreationSuccessMessage.value = `Case Created Successfully, kindly track your Request Status using your Case Number: ${res.data?.response?.caseNumber}`;

                caseLoading.value = false;

                // emit("toggleCreateModal");
              })
              .catch(() => {
                caseCreationError.value =
                  "Error in creating case, please try again";
                caseLoading.value = false;
                // console.log("I show face o");
              });
          } else {
            caseCreationError.value =
              "Error in creating case, please try again";

            caseLoading.value = false;
          }
        })
        .catch(() => {
          createCaseError.value = "Error in creating case, please try again";
          caseLoading.value = false;
        });
    };

    return {
      createContactCase,
      caseCreationSuccessMessage,
      caseLoading,
      caseCreationError,
    };
  },
};
</script>

<style></style>
